export default __webpack_public_path__ + "static/media/noImage.3d2be1a8.png";